/* =========================================================
   Dolls In Love — Torsos (Sigafun)
   Wörtlich aus Liebesppuppen.docx, den drei Einträgen am Dokumentende.
   Zu keinem der drei steht im Dokument ein Preis; nur Yuna hat ein Bild.
   Achtung: „Malia“ gibt es zweimal — als Puppe (Real Lady) und hier als Torso.
   ========================================================= */
window.DIL_TORSOS = [
 {
  "slug": "yuna",
  "name": "Yuna",
  "claim": "Deine persönliche Wohlfühloase",
  "lead": "Wenn du die Tür hinter dir schließt, zählt nur noch deine persönliche Entspannung. Yuna stellt keine Forderungen, kennt keine Launen und verlangt niemals Erklärungen von dir. Sie ist dein sicherer Hafen, der immer geduldig auf dich wartet, damit du den Stress des Alltags sofort vergessen kannst.",
  "bullets": ["Erwartungsfrei", "Handlich", "Formstabil"],
  "cta": "Komm an in deiner privaten Welt voller Vertrauen. Entdecke Yuna.",
  "quote": "Bei mir bist du vollkommen frei und sicher. Ich liebe deine Nähe und bin sehr schnell dort, wo du mich benutzen willst.",
  "hersteller": "Sigafun",
  "image": DIL.assets + "dil-torsos-yuna.jpg",
  "explizit": true
 },
 {
  "slug": "malia-torso",
  "name": "Malia",
  "claim": "Perfektion nach deinen Regeln",
  "lead": "Dein Leben ist dynamisch, und Malia passt sich deinem Rhythmus mühelos an. Durch ihr durchdachtes Design schenkt sie dir maximale Freiheit im Alltag. Sie bietet dir luxuriöse Intimität genau dann, wenn du bereit dafür bist, und lässt sich danach vollkommen unkompliziert handhaben.",
  "bullets": ["Platzsparend", "Diskret", "Pflegeleicht"],
  "cta": "Genieße Intimität nach deinen eigenen Regeln. Entdecke Malia.",
  "quote": "Ich richte mich ganz nach deinem Leben und deinen Wünschen – nimm mich einfach zu dir, wann immer du dich nach mir sehnst.",
  "hersteller": "Sigafun",
  "image": null,
  "explizit": false
 },
 {
  "slug": "suri",
  "name": "Suri",
  "claim": "Die pure Essenz der Berührung",
  "lead": "Manchmal liegt der größte Luxus darin, sich ganz auf das Wesentliche zu konzentrieren. Suri verzichtet auf alles Überflüssige und lenkt deine Sinne direkt auf ihre meisterhaft geformten Kurven. Ihre samtweiche, lebensechte Hautstruktur bietet dir ein unvergleichlich intensives und hautnahes Gefühl, das jeden deiner Abende bereichert.",
  "bullets": ["Sinnlich reduziert", "Formvollendet", "Realistisch"],
  "cta": "Erlebe Sinnlichkeit ohne Kompromisse. Entdecke Suri.",
  "quote": "Spüre meine Weichheit und lass dich ganz von meinen Kurven verzaubern – ich bin hier, um jeden deiner Momente perfekt zu machen.",
  "hersteller": "Sigafun",
  "image": null,
  "explizit": false
 }
];
